import React from 'react';
import DialogTitleMui from '@material-ui/core/DialogTitle';
import { DialogTitleProps } from '@material-ui/core';

export const DialogTitle: React.FC<DialogTitleProps> = ({ children, ...rest }) => {
	return <DialogTitleMui {...rest}>{children}</DialogTitleMui>;
};
